import "./Info.css";

const Info = () => {
  return (
    <section className="info-section py-5">
      <div className="container">
        <h2 className="section-title">BMI Categories</h2>
        <div className="row">
          <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
            <div className="info-card underweight">
              <h3>Underweight</h3>
              <p className="bmi-range">&lt; 18.5</p>
              <p>Indicates Health Risks</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
            <div className="info-card normal">
              <h3>Normal</h3>
              <p className="bmi-range">18.5 - 24.9</p>
              <p>Healthy weight range</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
            <div className="info-card overweight">
              <h3>Overweight</h3>
              <p className="bmi-range">25 - 29.9</p>
              <p>Increased health risks</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
            <div className="info-card obese">
              <h3>Obese</h3>
              <p className="bmi-range">≥ 30</p>
              <p>High Health Risk</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Info;